import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SelectComponent } from './select.component';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { RxButtonModule } from '../button/button.module';
import { RxInputModule } from '../input/input.module';
import { ClickOutsideModule } from '../../directives';
import { RxCheckboxModule } from '../checkbox/checkbox.module';
import { DropdownSearchComponent } from './components/dropdown-search/dropdown-search.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RxButtonModule,
    RxInputModule,
    RxCheckboxModule,
    ClickOutsideModule,
    ScrollingModule,
    DropdownSearchComponent
  ],
  declarations: [
    SelectComponent,
  ],
  exports: [
    SelectComponent,
  ],
})
export class RxSelectModule {}
